/**
 * mouth-tape-e only. A capture-phase click listener handles #add-to-cart-btn
 * before the inline onclick="addToCart()" from the shared buybox markup.
 * A and D never load this file, and the listener no-ops without
 * [data-sk-simplified-buybox="1"].
 *
 * Pack stays on the selected card (default "3"; the cards are not in the
 * layout). The only payload difference vs A is
 * properties._sk_simplified_buybox = "1".
 */
(function () {
  function readState() {
    var styleEl = document.querySelector('.variant-option.selected');
    var packEl = document.querySelector('.pack-card.selected');
    var toggle = document.getElementById('refill-toggle');
    var style = styleEl ? styleEl.getAttribute('data-style') : 'full';
    var pack = packEl ? packEl.getAttribute('data-pack') : '3';
    if (style !== 'slim' && style !== 'full') style = 'full';
    if (pack !== '1' && pack !== '3' && pack !== '6') pack = '3';
    return {
      style: style,
      pack: pack,
      isSubscription: !!(toggle && toggle.classList.contains('active'))
    };
  }

  function buttonHtml(state) {
    var display = SK_MOUTH_TAPE_ATC.display;
    var total = state.isSubscription ? display.sub[state.pack].total : display.oneTime[state.pack].total;
    var orig = state.isSubscription ? display.sub[state.pack].orig : '';
    return '<span class="cta-lock"><svg viewBox="0 0 24 24"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg></span> START NOW — <span class="cta-price">' + total + '</span>' + (state.isSubscription ? ' <span class="cta-original">' + orig + '</span>' : '');
  }

  function addToCartE() {
    var btn = document.getElementById('add-to-cart-btn');
    var successEl = document.getElementById('cart-success');
    var state = readState();
    var payload = skMouthTapeAtcPayload(state, { _sk_simplified_buybox: '1' });
    var variantKey = state.style + '-' + state.pack;

    if (!payload || !btn) {
      window.alert('Error: Could not find variant. Please try again.');
      return;
    }

    btn.classList.add('loading');
    btn.innerHTML = '⏳ Adding to cart...';

    var cartDrawer = document.querySelector('cart-drawer');
    var drawerSections = cartDrawer && cartDrawer.getSectionsToRender
      ? cartDrawer.getSectionsToRender().map(function (s) { return s.id; })
      : ['cart-drawer', 'cart-icon-bubble'];

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [payload], sections: drawerSections.join(',') })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart API returned ' + response.status);
        return response.json();
      })
      .then(function (data) {
        btn.classList.remove('loading');
        btn.innerHTML = '✅ Added!';

        if (cartDrawer && cartDrawer.renderContents && data.sections) {
          cartDrawer.renderContents(data, true);
          window.setTimeout(function () {
            if (!cartDrawer.isOpen) cartDrawer.toggleDrawerClasses();
          }, 100);
        } else {
          window.setTimeout(function () {
            var cartTrigger = document.querySelector('.wt-cart__trigger, #cart-icon-bubble, a[href="/cart"]');
            if (cartTrigger) cartTrigger.click();
          }, 500);
        }

        window.setTimeout(function () {
          var current = readState();
          var liveBtn = document.getElementById('add-to-cart-btn');
          if (liveBtn) liveBtn.innerHTML = buttonHtml(current);
        }, 3000);
      })
      .catch(function () {
        btn.classList.remove('loading');
        var host = window.location.hostname;
        var isShopify = host.indexOf('sleepkarma') !== -1 || host.indexOf('myshopify') !== -1;
        if (isShopify) {
          btn.innerHTML = '❌ Error — please try again';
          window.setTimeout(function () {
            var liveBtn = document.getElementById('add-to-cart-btn');
            if (liveBtn) liveBtn.innerHTML = buttonHtml(readState());
          }, 2000);
          return;
        }
        if (!successEl) return;
        var display = SK_MOUTH_TAPE_ATC.display;
        var price = state.isSubscription ? display.sub[state.pack].total : display.oneTime[state.pack].total;
        var planLine = state.isSubscription
          ? 'Selling Plan: <strong>' + state.pack + '-month subscription</strong> (ID: ' + payload.selling_plan + ')<br>'
          : 'One-time purchase<br>';
        successEl.innerHTML = '<div class="cart-success-text">🔧 Preview Mode — This would add to cart:</div>' +
          '<div style="font-size:13px;color:#555;margin-bottom:8px;">' +
          'Variant: <strong>' + variantKey + '</strong> (ID: ' + payload.id + ')<br>' +
          planLine +
          'Price: <strong>' + price + '</strong></div>' +
          '<div style="font-size:12px;color:#999;">When this HTML is on sleepkarma.co, it will POST to /cart/add.js and open the cart drawer.</div>';
        successEl.classList.add('show');
        btn.innerHTML = buttonHtml(state);
      });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('#add-to-cart-btn');
    if (!btn || btn.classList.contains('loading')) return;
    if (!document.querySelector('[data-sk-simplified-buybox="1"]')) return;
    if (typeof skMouthTapeAtcPayload !== 'function') return;
    event.preventDefault();
    event.stopPropagation();
    addToCartE();
  }, true);
})();
